module.exports = __webpack_public_path__ + "img/MK.611e09fe.png";